import { mapState } from "pinia";
import { defineComponent } from "vue";

import WidgetIndicator from '~/components/widget-indicator/widget-indicator.vue';
import ComponentBase from "~/components/component-base";
import { DashboardFilterEnum } from "~/models/dashboard/dashboard-filter.enum";
import { useDashboardStore } from "~/store/dashboard.store";

export default defineComponent({
    
    extends: ComponentBase,

    components: {
        WidgetIndicator,
    },

    data() {
        return { DashboardFilterEnum };
    },

    computed: {
        ...mapState(useDashboardStore, ['indicators']),

        count(): number {
            return this.indicators?.trouble?.value;
        },

        variation(): number { 
            return this.indicators?.trouble?.variation;
        },

        color(): string {
            if(this.variation > 0) {
              return 'has-text-danger';
            } else if (this.variation < 0) {
              return 'has-text-success';
            } else {
              return '';
            }
          }
    }
});